import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { CandidateItemProps } from "./model"
import { CandidateStatStrip } from "../candidateStats"

const cleanLocation = (loc: string) => loc?.replace(/\s*\(null\)/gi, "").trim() ?? ""

export const CandidateItem = ({ props }: any) => {
  const candidateProps = props as CandidateItemProps
  const navigate = useNavigate()
  const [showPhoto, setShowPhoto] = useState(false)

  const onItemClick = (candidateId: string) => {
    navigate(`/${candidateProps.url}/${candidateId}`)
  }

  return (
      <>
        {showPhoto && candidateProps.profilePictureUrl && (
            <div
                className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70"
                onClick={() => setShowPhoto(false)}
            >
              <img
                  src={candidateProps.profilePictureUrl}
                  alt={`${candidateProps.firstName} ${candidateProps.lastName}`}
                  className="max-h-[80vh] max-w-[80vw] rounded-[16px] object-contain shadow-xl"
                  onClick={(e) => e.stopPropagation()}
              />
            </div>
        )}

      <div
          className="candidate-item mt-4 cursor-pointer"
          id={candidateProps.id}
          onClick={() => onItemClick(candidateProps.id)}
      >
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:gap-6">
          <div className="flex min-w-0 flex-1 items-center">
            <div className="relative flex h-[72px] w-[72px] shrink-0 rounded-full bg-figmaLightBg">
              <div className="m-auto flex h-[70px] w-[70px] items-center justify-center rounded-full bg-figmaSpecialBlue bg-opacity-25">
                {candidateProps.profilePictureUrl != null ? (
                    <img
                        src={candidateProps.profilePictureUrl}
                        className="h-[70px] w-[70px] rounded-full object-cover"
                        alt={`${candidateProps.firstName} ${candidateProps.lastName}`}
                        onClick={(e) => { e.stopPropagation(); setShowPhoto(true) }}
                    />
                ) : (
                    <p className="text-base font-semibold text-figmaBlack">
                      {candidateProps.firstName[0]}
                      {candidateProps.lastName[0]}
                    </p>
                )}
              </div>
              {candidateProps.isFavourite && (
                  <div className="absolute -top-1 -right-1 flex h-5 w-5 items-center justify-center rounded-full bg-yellow-400 shadow-sm">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" className="h-3 w-3">
                      <path fillRule="evenodd" d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z" clipRule="evenodd" />
                    </svg>
                  </div>
              )}
            </div>

            <div className="ml-4 min-w-0 sm:ml-5">
              <p className="candidate-item-name break-words text-base sm:text-lg">
                {candidateProps.firstName} {candidateProps.lastName}
              </p>

              <p className="text-figmaPrimary text-[13px] sm:text-[14px] break-words">
                {candidateProps.preferredGigTitles?.[0] ?? ""}
              </p>

              <div className="mt-2 flex min-w-0 items-center gap-2">
                <img src="/images/navigation.svg" alt="location" className="shrink-0" />
                <p className="text-figmaDarkGray text-[13px] break-words">
                  {cleanLocation(candidateProps.location)}
                </p>
              </div>
            </div>
          </div>

          <CandidateStatStrip
            rating={candidateProps.rating}
            responseRate={candidateProps.responseRate}
            attendance={candidateProps.attendance}
          />
        </div>
      </div>
      </>
  )
}